import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { TTradeDetailsById } from "../types/trades/trades";
import { numberPrecision } from "../helpers/getText";

export type TAddInvoiceDetails = {
  Disc: number;
  DelayCharges: number;
  pfPer: number;
  pf: number;
  Dis: number;
  totalPayReceive: number;
  finalPayReceive: number;
  invAmt: number;
  advancePaidRcvd: number;
  freightPaidReceive: number;
  lbrCharges: number;
  misc: number;
  commPer: number;
  comm: number;
  otherCharges: number;
  mandiFee: number
};


type TInitialState = {
  addSrcInvoiceDetails: TAddInvoiceDetails;
  addDestInvoiceDetails: TAddInvoiceDetails;
  traderType: string;
  tradeId: number;
};

const initialState: TInitialState = {
  traderType: "",
  tradeId: 0,
  addSrcInvoiceDetails: {
    Disc: 0,
    DelayCharges: 0,
    pfPer: 0,
    pf: 0,
    Dis: 0,
    totalPayReceive: 0,
    finalPayReceive: 0,
    invAmt: 0,
    advancePaidRcvd: 0,
    freightPaidReceive: 0,
    lbrCharges: 0,
    misc: 0,
    commPer: 0,
    comm: 0,
    otherCharges: 0,
    mandiFee: 0
  },
  addDestInvoiceDetails: {
    Disc: 0,
    DelayCharges: 0,
    pfPer: 0,
    pf: 0,
    Dis: 0,
    totalPayReceive: 0,
    finalPayReceive: 0,
    invAmt: 0,
    advancePaidRcvd: 0,
    freightPaidReceive: 0,
    lbrCharges: 0,
    misc: 0,
    commPer: 0,
    comm: 0,
    otherCharges: 0,
    mandiFee: 0
  }
};

export const invoiceDetails = createSlice({
  name: "invoiceDetails",
  initialState: initialState,
  reducers: {
    resetArrivalDetails: (state) => {
      return {
        ...initialState,
      };
    },

    setAddSrcInvoice: (state, action: PayloadAction<{
      tradeDetail: TTradeDetailsById,
    }>) => {
      let tradeDetail = action.payload.tradeDetail;

      state.addSrcInvoiceDetails.Disc = Number(tradeDetail?.srcDisc);
      state.addSrcInvoiceDetails.pfPer = numberPrecision(Number(tradeDetail?.srcPf) * 100 / Number(tradeDetail?.invAmt));
      state.addSrcInvoiceDetails.pf = Number(tradeDetail?.srcPf);
      state.addSrcInvoiceDetails.Dis = Number(tradeDetail?.srcDis);
      state.addSrcInvoiceDetails.totalPayReceive = Number(tradeDetail?.totalReceivable);
      state.addSrcInvoiceDetails.finalPayReceive = Number(tradeDetail?.finalReceivable);
      state.addSrcInvoiceDetails.invAmt = Number(tradeDetail?.invAmt);
      // state.addSrcInvoiceDetails.advancePaidRcvd = Number(calculateAdvancePaidSrc(tradeDetail?.pmtHistory));
      state.addSrcInvoiceDetails.advancePaidRcvd = Number(tradeDetail?.srcAdv);
      state.addSrcInvoiceDetails.freightPaidReceive = Number(tradeDetail?.freightPaid);
      state.addSrcInvoiceDetails.lbrCharges = Number(tradeDetail?.lbrCharges);
      state.addSrcInvoiceDetails.otherCharges = Number(tradeDetail?.otherCharges);
      state.addSrcInvoiceDetails.mandiFee = Number(tradeDetail?.mandiFee);
      state.addSrcInvoiceDetails.misc = Number(tradeDetail?.misc);
      state.addSrcInvoiceDetails.commPer = parseFloat(
        (
          (Number(tradeDetail?.comm) * 100) /
          Number(tradeDetail?.invAmt)
        ).toFixed(2)
      );
      state.addSrcInvoiceDetails.comm = Number(tradeDetail?.comm)
    },
    setAddDestInvoice: (state, action: PayloadAction<{
      tradeDetail: TTradeDetailsById,
    }>) => {
      let tradeDetail = action.payload.tradeDetail;

      state.addDestInvoiceDetails.Disc = Number(tradeDetail?.destDisc);
      state.addDestInvoiceDetails.DelayCharges = tradeDetail?.destDelayCharges;
      state.addDestInvoiceDetails.pfPer = numberPrecision(Number(tradeDetail?.destPf) * 100 / Number(tradeDetail?.invAmt));
      state.addDestInvoiceDetails.pf = Number(tradeDetail?.destPf);
      state.addDestInvoiceDetails.Dis = Number(tradeDetail?.destDis);
      state.addDestInvoiceDetails.totalPayReceive = Number(tradeDetail?.totalPayable);
      state.addDestInvoiceDetails.finalPayReceive = Number(tradeDetail?.finalPayable);
      state.addDestInvoiceDetails.invAmt = Number(tradeDetail?.invAmt);
      // state.addDestInvoiceDetails.advancePaidRcvd = Number(calculateAdvancePaid(tradeDetail?.pmtHistory));
      state.addDestInvoiceDetails.advancePaidRcvd = Number(tradeDetail?.destAdv)
      state.addDestInvoiceDetails.freightPaidReceive = Number(tradeDetail?.freightPaid);
      state.addDestInvoiceDetails.lbrCharges = Number(tradeDetail?.lbrCharges);
      state.addDestInvoiceDetails.otherCharges = Number(tradeDetail?.otherCharges);
      state.addDestInvoiceDetails.mandiFee = Number(tradeDetail?.mandiFee);
      state.addDestInvoiceDetails.misc = Number(tradeDetail?.misc);
      state.addDestInvoiceDetails.commPer = parseFloat(
        (
          (Number(tradeDetail?.comm) * 100) /
          Number(tradeDetail?.invAmt)
        ).toFixed(2)
      );
      state.addDestInvoiceDetails.comm = Number(tradeDetail?.comm)
    },

    udpateAddSrcInvoice: (
      state,
      action: PayloadAction<{
        srcInvoice: TAddInvoiceDetails;
      }>
    ) => {
      state.addSrcInvoiceDetails = action.payload.srcInvoice;
    },
    udpateAddDestInvoice: (
      state,
      action: PayloadAction<{
        destInvoice: TAddInvoiceDetails;
      }>
    ) => {
      state.addDestInvoiceDetails = action.payload.destInvoice;
    },
  },
});

export const { setAddSrcInvoice, setAddDestInvoice, udpateAddSrcInvoice, udpateAddDestInvoice } =
  invoiceDetails.actions;
export default invoiceDetails.reducer;
